import Vue from 'vue'
import Router from 'vue-router'
import state from '../store/index'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
import approvalRouter from '@/views/approvalCenter/router/index'
import openPlatformRouter from '@/views/openPlatform/router/index'
// 系统管理路由
import sysManageRouter from '@/views/sysManage/router/index'

// 表单管理路由
import formRouter from '@/views/form/router/index'
// 任务管理
import taskManageRouter from '@/views/taskManage/router/index'

// 流程管理
import processManageRouter from '@/views/processManage/router/index'

// 企业管理后台
import companyManageRouter from '@/views/companyManage/router/index'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home/index',
    children: [
      {
        path: '/home/index',
        component: () => import('@/views/approvalCenter/page/home.vue'),
        name: 'ApprovalCenter',
        // permissionCode: '31598',
        meta: { title: '首页', icon: 'nav-home', affix: true, onlyMenu: true }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const approvalRoutes = [approvalRouter]
export const asyncRoutes = [
  processManageRouter,
  taskManageRouter,
  openPlatformRouter,
  sysManageRouter,
  formRouter,
  /** when your routing map is too long, you can split it into small modules **/
  // {
  //   path: '/theme',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/theme/index'),
  //       name: 'Theme',
  //       meta: { title: 'Theme', icon: 'theme' }
  //     }
  //   ]
  // },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

// 超级管理员路由
export const adminRoutes = [companyManageRouter]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()
router.beforeEach(async(to, from, next) => {
  const { uuid } = to.query
  // const { inFrame } = state.app
  if (uuid) {
    state.commit('app/SET_IN_FRAME', true)
    // 从iframe嵌套请求用户信息
    await new Promise((resolve, reject) => { resolve() })
    next()
  } else {
    const isConsole = sessionStorage.getItem('isConsole')

    if (isConsole) {
      if (isConsole && !to.query.isConsole) {
        next({
          path: to.path,
          query: Object.assign(to.query, { isConsole: true })
        })
      } else {
        next()
      }
    } else {
      const isYc = sessionStorage.getItem('isYc')
      if (isYc && !to.query.isYc) {
        console.log('beforeEach1', to)
        next({
          path: to.path,
          query: Object.assign(to.query, { isYc: true })
        })
      } else {
        console.log('beforeEach2', to)
        next()
      }
    }
  }
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

const sourceWarn = window.console.warn
// 复写warn方法方便检查由于使用name跳转无法监控404的问题
window.console.warn = function(...rest) {
  const args = Array.from(rest)
  if (args[0] && args[0].includes('Route with name') && args[0].includes('does not exist')) {
    setTimeout(() => {
      router.push('/404')
    }, 0)
  }
  sourceWarn(...rest)
}

export default router
